import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import css from './ExploreMenu.module.css';

/** Shared entry to the exploration choice, on desktop and mobile. */
const ExploreMenu = ({ onOpen }) => (
  <NamedLink name="ExplorePage" className={css.trigger} onClick={onOpen}>
    <FormattedMessage id="Topbar.explore" />
  </NamedLink>
);

export default ExploreMenu;
